import React, { memo, useContext, useEffect, useState } from "react";
import { Autocomplete, Input, TextField } from "@mui/material";

import { RetornoLoteContext } from "../../Context/RetornoLoteContext";
import { RecebimentoContext } from "../../Context/RecebimentoContext";

function InputMotivo({ row, disabled }) {
  const { setGlosas } = useContext(RetornoLoteContext);
  const { motivos } = useContext(RecebimentoContext);

  const { id, motivo } = row;
  const [motivoAtual, setMotivoAtual] = useState({
    id,
    descricao: motivo,
    codigo: 0,
    codigoDescricao: motivo ? motivo : "",
  });
  const [motivoInvalido, setMotivoInvalido] = useState(false);

  useEffect(() => {
    if (motivoAtual) {
      const v = Number(motivoAtual);

      const valido = motivos.includes(v);

      setMotivoInvalido(!valido);
    }
    // eslint-disable-next-line
  }, [motivoAtual]);

  function alteraMotivo(valor) {
    setGlosas((prevState) => {
      const novoMotivo = prevState;
      const resultado = novoMotivo.map((item) => {
        if (item.id === id) {
          return { ...item, motivo: valor };
        }
        return { ...item };
      });

      return resultado;
    });
  }

  return (
    <>
      <Autocomplete
        fullWidth
        disabled={disabled}
        options={motivos}
        getOptionLabel={(option) => option.codigoDescricao || ""}
        onChange={(event, value) => setMotivoAtual(value)}
        value={motivoAtual}
        onBlur={(event) => alteraMotivo(event.target.value)}
        sx={{
          "& .MuiInputBase-root": {
            backgroundColor: "rgba(255,255,255,0.9)",
            borderRadius: 1,
            border: "1px solid #ccc",
            paddingLeft: "4px",
            "&.Mui-disabled": {
              backgroundColor: "#f0f0f0",
              color: "#777",
              cursor: "not-allowed",
              "*": { cursor: "not-allowed !important" },
            },
          },
          "& .MuiInputBase-input": {
            padding: "6px 8px",
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            fullWidth
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
          />
        )}
      />
    </>
  );
}

export default memo(InputMotivo);
